import { blue, green, purple } from '@ant-design/colors'
import {
  AndroidOutlined,
  AppleOutlined,
  WhatsAppOutlined,
} from '@ant-design/icons'
import { Platform, PlatformSlug } from '../../../../models/Platform'

const platforms: Record<PlatformSlug, Platform> = {
  ios: {
    slug: 'ios',
    name: 'iOS',
    color: purple,
    icon: (
      <AppleOutlined
        style={{
          color: purple[6],
        }}
      />
    ),
  },
  android: {
    slug: 'android',
    name: 'Android',
    color: blue,
    icon: (
      <AndroidOutlined
        style={{
          color: blue[6],
        }}
      />
    ),
  },
  whatsapp: {
    slug: 'whatsapp',
    name: 'WhatsApp',
    color: green,
    icon: (
      <WhatsAppOutlined
        style={{
          color: green[6],
        }}
      />
    ),
  },
}

export { platforms }
